module.exports = __webpack_public_path__ + "static/media/barbarian_head.30beff94.svg";